import { createAsyncThunk } from "@reduxjs/toolkit";

import LegalVerificationsAPI, {
  MessageResponse,
  GetLegalVerificationsResponse,
  UpsertLegalVerificationsParams,
} from "../../../api/legalVerifications";
import { RootState } from "../../../app/store";

export const fetchLegalVerifications = createAsyncThunk<
  GetLegalVerificationsResponse,
  string,
  { state: RootState; rejectValue: string }
>(
  "legalVerifications/fetchLegalVerifications",
  async (caseId, { rejectWithValue }) => {
    try {
      const response = await LegalVerificationsAPI.getLegalVerifications({
        case_id: caseId,
      });

      return response;
    } catch {
      return rejectWithValue("Failed to fetch legal verifications");
    }
  },
  {
    condition(caseId, { getState }) {
      const legalVerificationsState = getState().legalVerifications;

      if (
        legalVerificationsState.caseId === caseId &&
        (legalVerificationsState.status === "loading" ||
          legalVerificationsState.status === "success")
      ) {
        return false;
      }

      return true;
    },
  },
);

export const upsertLegalVerifications = createAsyncThunk<
  MessageResponse,
  UpsertLegalVerificationsParams,
  { rejectValue: string }
>(
  "legalVerifications/upsertLegalVerifications",
  async (params, { rejectWithValue }) => {
    try {
      const response =
        await LegalVerificationsAPI.upsertLegalVerifications(params);

      return response;
    } catch {
      return rejectWithValue("Failed to save legal verifications");
    }
  },
);
